import React from 'react';
import { motion } from 'framer-motion';
import ProfileImg from '../../images/profile.jpg';
import './Home.css';

const Home = () => {
  const scrollToAbout = () => {
    document.getElementById('aboutMeBlock')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="home-container">
      <motion.div
        className="hero-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <motion.div
          className="avatar-container glass-panel"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <img src={ProfileImg} alt="Rooshhil Patel" className="avatar-img" />
        </motion.div>

        <h1 className="hero-title sr-only">Rooshhil Patel</h1>
        <motion.div
          className="hero-name"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
        >
          <span className="hero-first-name text-gradient">Rooshhil</span>
          <span className="hero-last-name text-gradient">Patel</span>
        </motion.div>

        <motion.p
          className="hero-subtitle"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 1 }}
        >
          Crafting Digital Experiences
        </motion.p>

        <motion.button
          className="skeuo-button cta-btn"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.2, duration: 0.6, ease: "easeOut" }}
          onClick={scrollToAbout}
        >
          Explore Work
        </motion.button>
      </motion.div>
    </div>
  );
};

export default Home;
